import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  items: [],
  archivedItems: [],
  isLoadingArchived: false,

  containerDesign: {},
  itemDesign: {},
  defaultItem: {},

  sublinksOpenIds: [],
  activeItem: null,
  blockContent: {},
  blockDesign: {
    view: 'classic',
  },
};

export const linksSlice = createSlice({
  name: 'links',
  initialState,
  reducers: {
    linksStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;
      const block = data ?? {};
      const { blockContent, blockDesign, blockSettings } = block;
      const { links = [] } = blockContent;
      const { containerDesign, itemDesign } = blockDesign;
      // const { defaultItem } = blockSettings;

      state.isLoading = false;

      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      const filteredLinks = (links ?? []).filter((link) => {
        return !link.parentLinkId || link.parentLinkId === 0;
      });

      state.items = filteredLinks;
      state.containerDesign = containerDesign ?? {};
      state.itemDesign = itemDesign ?? {};
      state.blockDesign = {
        ...blockDesign,
        view: blockDesign.view ?? 'classic',
      };
      state.defaultItem = blockSettings?.defaultItem ?? {};
    },
    linksClear: () => initialState,

    linksUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    linksUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    linksUpdateItems: (state, action) => {
      const filteredLinks = (action.payload ?? []).filter((link) => {
        return !link.parentLinkId || link.parentLinkId === 0;
      });
      state.items = filteredLinks;
    },
    linksUpdateItemDesign: (state, action) => {
      state.itemDesign = action.payload;
    },
    linksUpdateDefaultItem: (state, action) => {
      state.defaultItem = action.payload;
    },
    linksUpdateSublinksOpenIds: (state, action) => {
      state.sublinksOpenIds = action.payload;
    },
    linksUpdateActiveItem: (state, action) => {
      state.activeItem = action.payload;
    },
    linksUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
    linksUpdateArchivedItems: (state, action) => {
      state.archivedItems = action.payload;
    },
    linksUpdateIsLoadingArchived: (state, action) => {
      state.isLoadingArchived = action.payload;
    },
  },
});

export const {
  linksStore,
  linksClear,
  linksUpdateIsLoading,
  linksUpdateIsActive,
  linksUpdateItems,
  linksUpdateItemDesign,
  linksUpdateDefaultItem,
  linksUpdateSublinksOpenIds,
  linksUpdateActiveItem,
  linksUpdateBlockDesign,
  linksUpdateArchivedItems,
  linksUpdateIsLoadingArchived,
} = linksSlice.actions;

export const selectLinksIsLoading = (state) => state.links.isLoading;

export const selectLinksIsActive = (state) => state.links.isActive;
export const selectLinksId = (state) => state.links.id;
export const selectLinksUID = (state) => state.links.uid;
export const selectLinksSID = (state) => state.links.sid;

export const selectLinksItems = (state) => state.links.items;
export const selectLinksContainerDesign = (state) => state.links.containerDesign;
export const selectLinksItemDesign = (state) => state.links.itemDesign;
export const selectLinksDefaultItem = (state) => state.links.defaultItem;

export const selectLinksSublinksOpenIds = (state) => state.links.sublinksOpenIds;
export const selectLinksActiveItem = (state) => state.links.activeItem;

export const selectLinksArchivedItems = (state) => state.links.archivedItems;
export const selectLinksIsLoadingArchived = (state) => state.links.isLoadingArchived;

export const selectLinksBlockContent = (state) => state.links.blockContent;
export const selectLinksBlockDesign = (state) => state.links.blockDesign;

export default linksSlice.reducer;
